var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13379 9.96411L8.13379 3.03591L9.86584 4.03591L5.86584 10.9641L4.13379 9.96411Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "static/media/tree-divide-icon.f48b32b1.svg";
export { SvgComponent as ReactComponent };